import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/launch';
const steps = [{
  title: 'Open KittyPot and sign in.'
}, {
  title: 'Go to Settings → Delete account.'
}, {
  title: 'Confirm.',
  detail: 'We remove or anonymise your account information where appropriate. Limited shared records may need to remain so other members’ shared expense history and balances stay accurate.'
}];
export function DeleteAccount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-448" data-mp="2cdl9r2faqtii">
      <SEO title="Delete your KittyPot account | KittyPot" description="How to permanently delete your KittyPot account from the app, and what happens to your data when you do." ogTitle="Delete your KittyPot account" ogDescription="How to permanently delete your KittyPot account and what happens to your data." path="/delete-account" data-id="element-449" data-mp="27erx1c7u36je" />
      <Navbar data-id="element-450" data-mp="qoamm3789s9c" />
      <main className="pt-36 pb-24" data-id="element-451" data-mp="qo14t2wc6req">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-452" data-mp="qp2kxls7m43b">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-453" data-mp="1edc22aeha3o4">
            <h1 className="text-4xl md:text-5xl font-black text-kitty-dark mb-5 tracking-tight" data-id="element-454" data-mp="1id4cksnfmjw4">
              Delete your KittyPot account
            </h1>
            <p className="text-lg text-gray-500 mb-12 max-w-xl" data-id="element-455" data-mp="19dpk5nnpfz8z">
              You can permanently delete your KittyPot account from the app:
            </p>
          </motion.div>

          <motion.ol initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="space-y-4 mb-12" data-id="element-456" data-mp="3u59nfoyw1vai">
            {steps.map((step, index) => <li key={step.title} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-7 flex gap-5" data-id="element-457" data-mp="363ntq9fgeb0w" data-mpi={index}>
                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center" data-id="element-458" data-mp="2wayvig8wytni">
                  {index + 1}
                </span>
                <div data-id="element-459" data-mp="2mbr973k7boo9">
                  <p className="text-lg font-bold text-kitty-dark leading-snug" data-id="element-460" data-mp="2mff4a75aoj53">
                    {step.title}
                  </p>
                  {step.detail && <p className="text-gray-500 leading-relaxed mt-2" data-id="element-461" data-mp="2de74fkn4ra8w">
                      {step.detail}
                    </p>}
                </div>
              </li>)}
          </motion.ol>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-gray-950 rounded-2xl p-8 md:p-10 text-white" data-id="element-462" data-mp="bj6md700yska">
            <div className="w-11 h-11 rounded-2xl bg-white/[0.08] flex items-center justify-center mb-5" data-id="element-463" data-mp="subsa6uyy9bg">
              <MailIcon className="w-5 h-5 text-kitty-yellow" aria-hidden="true" data-id="element-464" data-mp="xsn2wjt38nuq" />
            </div>
            <h2 className="text-xl font-bold mb-3" data-id="element-465" data-mp="895qrf81jrf">Cannot open the app?</h2>
            <p className="text-gray-400 leading-relaxed" data-id="element-466" data-mp="55j10npakpn6">
              Email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-yellow underline underline-offset-2 transition-colors hover:text-kitty-yellow-500" data-id="element-467" data-mp="a3awtst24vwn">
                {SUPPORT_EMAIL}
              </a>{' '}
              from the email on your KittyPot account and ask us to delete it.
              We will check it is you first.
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-sm text-gray-500 mt-8" data-id="element-468" data-mp="1o5rvarhtg0w8">
            For more on how we handle your data, read our{' '}
            <a href="https://www.kittypot.com/privacy-policy/" className="font-semibold text-kitty-dark underline underline-offset-2 transition-colors hover:text-kitty-yellow-700" data-id="element-469" data-mp="1t176fbofvioy">
              Privacy Policy
            </a>
            .
          </motion.p>
        </div>
      </main>
      <Footer data-id="element-470" data-mp="2gu76t41qo12t" />
    </div>;
}